// Barrel re-export — Phase 7 dispatch resolves `account` page here.
// The account shell covers /profile, /orgs, and /account/* routes.
export { profile as account } from '../profile.js'
export { profile as default } from '../profile.js'
